export default __webpack_public_path__ + "static/media/contractor_new_logo.3573b53a.svg";